// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1431":"css/admin-app.6710","3749":"css/app.6710"}[chunkId] + ".css";
};